import { createFileRoute } from '@tanstack/react-router';

import { ensureEstateQueryData } from '@/features/estates-property/api/estate';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/'
)({
  loader: ensureEstateQueryData,
});
